import React from 'react';

interface ChartConfigPanelProps {
    allKeys: string[];
    data: any[];
    labelsKey: string;
    valueKeys: string[];
    onLabelsKeyChange: (key: string) => void;
    onValueKeysChange: (keys: string[]) => void;
}

const ChartConfigPanel: React.FC<ChartConfigPanelProps> = ({
    allKeys,
    data,
    labelsKey,
    valueKeys,
    onLabelsKeyChange,
    onValueKeysChange,
}) => {
    const numericKeys = allKeys.filter(k => typeof data?.[0]?.[k] === 'number');
    const textKeys = allKeys.filter(k => typeof data?.[0]?.[k] !== 'number');

    return (
        <div className="mb-4 p-4 bg-gray-50 border rounded-md">
            <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    X-Axis (Label Column)
                </label>
                <select
                    value={labelsKey}
                    onChange={(e) => onLabelsKeyChange(e.target.value)}
                    className="w-full border border-gray-300 rounded px-2 py-1 text-sm text-gray-800 bg-white"
                >
                    {allKeys.map((col) => (
                        <option key={col} value={col} className="text-gray-800">
                            {col}
                        </option>
                    ))}
                </select>

            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    Y-Axis (Numeric Values)
                </label>
                <div className="flex flex-wrap gap-3">
                    {numericKeys.map((key) => (
                        <label key={key} className="flex items-center gap-2 text-sm text-gray-800">
                            <input
                                type="checkbox"
                                checked={valueKeys.includes(key)}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        onValueKeysChange([...valueKeys, key]);
                                    } else {
                                        onValueKeysChange(valueKeys.filter(k => k !== key));
                                    }
                                }}
                            />
                            {key}
                        </label>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ChartConfigPanel;
